import { Component, Input, OnInit } from '@angular/core';
import { IMovementScheduleComponent, IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import Debug from 'debug';
import { MovementScheduleHelper } from '../../../helpers/movementSchedule.helper';
import { IMovementScheduleDates } from '../../../interfaces/movement-schedule/IMovementScheduleDates.interface';
import { IMovementSchedulePrintPreview } from '../../../interfaces/movement-schedule/IMovementSchedulePrintPreview.interface';

const debug = Debug('aumico:aumico-lib-notes-fe:MovementSchedulePrintPreviewComponent');

@Component({
    selector: 'aumico-notes-movements-schedule-print-preview-deprecated',
    templateUrl: 'movement-schedule-print-preview-deprecated.component.html',
    styleUrls: ['movement-schedule-print-preview-deprecated.component.scss'],
})
export class MovementSchedulePrintPreviewComponent implements OnInit {
    readonly mockedIndex = '0';
    currentDates: IMovementScheduleDates;
    previousDates: IMovementScheduleDates;

    movementSchedulePrintPreviewData: IMovementSchedulePrintPreview;
    @Input() set data(value: IMovementScheduleComponent) {
        if (value != null) {
            this.currentDates = {
                balanceCloseDate: value.currentBalanceYearDate,
                balanceOpenDate: value.previousBalanceYearDate,
                incomeCloseDate: value.currentIncomeYearDate,
                incomeOpenDate: value.previousIncomeYearDate,
            };
            this.movementSchedulePrintPreviewData = this.movementScheduleHelper.getMovementSchedulePrintPreviewData(
                value.flis,
                value.previousMovementScheduleComponent,
            );
            this.handlePreviousMovementScheduleDates(value.previousMovementScheduleComponent);
        }
    }

    @Input() currentLanguage = 'de-ch';

    @Input() accordionIndex = '0';

    @Input() numberFormat = '1.2-2';

    @Input()
    stylePreferenceOptions: IStyleOptions;

    @Input() noPreviousData: boolean;

    constructor(private movementScheduleHelper: MovementScheduleHelper) {}

    ngOnInit(): void {
        debug('ngOnInit');
    }

    private handlePreviousMovementScheduleDates(previousMovementSchedule: IMovementScheduleComponent) {
        if (previousMovementSchedule != null) {
            this.previousDates = {
                balanceCloseDate: previousMovementSchedule.currentBalanceYearDate,
                balanceOpenDate: previousMovementSchedule.previousBalanceYearDate,
                incomeCloseDate: previousMovementSchedule.currentIncomeYearDate,
                incomeOpenDate: previousMovementSchedule.previousIncomeYearDate,
            };
        }
    }
}
